var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorelocator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.094 6.994H13.906A6.919 6.919 0 0 0 7 13.905V56.1a6.919 6.919 0 0 0 6.911 6.911h42.183a6.919 6.919 0 0 0 6.911-6.911V13.905a6.919 6.919 0 0 0-6.911-6.911ZM8.995 23.939h19.572v6.372H8.995Zm4.911-14.945h14.661v12.945H8.995v-8.034a4.916 4.916 0 0 1 4.911-4.911ZM8.995 56.1V32.311h19.572v28.7H13.906A4.916 4.916 0 0 1 8.995 56.1Zm52.01 0a4.916 4.916 0 0 1-4.911 4.911H30.567V8.994h25.527a4.916 4.916 0 0 1 4.911 4.911Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.824 21.939a8.879 8.879 0 0 0-8.868 8.869c0 3.254 2.082 5.711 3.919 7.878 1.651 1.949 3.211 3.789 3.211 5.957a1.741 1.741 0 0 0 3.477 0c0-2.168 1.56-4.008 3.211-5.957 1.837-2.167 3.918-4.624 3.918-7.878a8.879 8.879 0 0 0-8.868-8.869Zm3.425 15.454a15.259 15.259 0 0 0-3.425 5.393 15.257 15.257 0 0 0-3.424-5.393c-1.771-2.09-3.444-4.064-3.444-6.585a6.868 6.868 0 1 1 13.736 0c0 2.521-1.672 4.492-3.443 6.585Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.824 26.794a4.16 4.16 0 1 0 4.16 4.159 4.164 4.164 0 0 0-4.16-4.159Zm0 6.319a2.16 2.16 0 1 1 2.16-2.16 2.161 2.161 0 0 1-2.16 2.16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorelocator);
export default __webpack_public_path__ + "static/media/storelocator.d39f9395af2b599f3059b25e8b83b069.svg";
export { ForwardRef as ReactComponent };